/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import CustomDialog from '../../../../Components/Dialog/CustomDialog';

const LeadsOriginDialog = function LeadsOriginDialog({
  open,
  close,
  title,
  onSubmit,
  leadOriginData,
}) {
  const intl = useIntl();

  const [leadOrigin, setLeadOrigin] = useState(null);

  useEffect(() => {
    if (open && typeof leadOriginData !== 'boolean') {
      setLeadOrigin(leadOriginData.leadOrigin);
    }
  }, [open]);

  const handleChange = (e) => {
    setLeadOrigin(e.target.value);
  };
  const handleSubmit = () => {
    onSubmit({
      id: leadOriginData.id || 'newLeadOrigin',
      leadOrigin,
    });
  };

  const reset = () => {
    setLeadOrigin(null);
  };

  return (
    <CustomDialog
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          close();
          reset();
        }
      }}
      disableEscapeKeyDown
      notRequiredFields
      messageDialog
      maxWidth="xs"
      fullWidth
      onSubmit={() => {
        handleSubmit();
        reset();
      }}
      submitDisabled={!leadOrigin}
      noBackdrop
      noForm
    >
      <TextField
        id="leadsOrigin-txtField"
        onChange={handleChange}
        label={intl.messages.LEAD_ORIGIN}
        required
        fullWidth
        value={leadOrigin}
        type="text"
      />
    </CustomDialog>
  );
};

LeadsOriginDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  leadOriginData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default LeadsOriginDialog;
